import React, { useEffect, useState, useMemo } from "react";
// import "./AdminUserList.css";
// import "../../components/CommonStyle.css";
import AdminUserService from "../../services/adminUserServices";
import { useTable, Column, useSortBy } from "react-table";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ReactModal from "react-modal";
// import { Label } from "@mui/icons-material";
// import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
import "../../Styles/CommonStyles.scss";
import EditIcon from "@mui/icons-material/Edit";
import { useAppSelector } from "../../store/hooks";

interface AddFormValue {
  FirstName: string | null;
  LastName: string | null;
  Email: string | null;
  Roles: number;
  Capabilities: string | null;
  Status: number;
}

// interface Istate {
//   data: {
//     FirstName: string;
//     LastName: string;
//     Email: number;
//     RoleName: string;
//   }
// }

const AdminUserList: React.FC = () => {
  // const[state, setState]  = useState<IAdminList>();
  const [adminList, setAdminList] = useState<any[] | undefined>([]);
  const [adminRoleList, setadminRoleList] = useState<any>();
  const [selectedAdminCapabilities, setselectedAdminCapabilities] =
    useState<any>();
  const [Id, setId] = useState<number>(1);
  const [selectedRow, setSelectedRow] = useState<any | undefined>();
  const [addUserOpen, setaddUserOpen] = useState<boolean>(false);
  const [isRoleSelected, setisRoleSelected] = useState<boolean>(false);
  const [isEdit, setisEdit] = useState<boolean>(false);
  const [isEmailEdit, setisEmailEdit] = useState<boolean>(false);
  const [isUpdate, setisUpdate] = useState<boolean>(false);

  const [dialogTitle, setdialogTitle] = useState<string>("Add User");
  const [buttonName, setbuttonName] = useState<string>("Add");
  const form = useForm<AddFormValue>();
  const { register, handleSubmit, formState, setValue, reset } = form;
  const { errors } = formState;
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  // const [state, setState] = useState<Istate>({
  //   data: {
  //     FirstName: '',
  //     LastName: '',
  //     Email: 0,
  //     RoleName: ''
  //   }
  // })
  useEffect(() => {
    getAdminList();
    getRole();
  }, []);

  const getAdminList = async () => {
    console.log("getAdminList called");
    const response = await AdminUserService.getAdminList();
    console.log("response", response);
    if (response.data.data != null) {
      console.log("Success");
      response.data.data?.forEach((element: any) => {
        element["CapabilitiesArr"] = element.AdminCapabilities.split(", ");
      });
      setAdminList(response.data.data);
      console.log(" yes;", adminList);
    } else {
    }
  };

  const showCapabilities = (row: any) => {
    console.log(row);
    setSelectedRow(row);
    setValue("FirstName", row.FirstName);
    setValue("LastName", row.LastName);
    setValue("Email", row.Email);
    setValue(
      "Roles",
      row.RoleName == "admin"
        ? 1
        : row.RoleName == "Moderator"
        ? 2
        : row.RoleName == "Member Moderator"
        ? 3
        : row.RoleName == "Event Manager"
        ? 4
        : 0
    );
    setValue("Capabilities", row.AdminCapabilities);
    setValue("Status", row.Status.toString());
    setId(row.Id);
    setisEdit(true);
    setisEmailEdit(true);
    setdialogTitle("View User");
    setaddUserOpen(true);
  };

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "Id", Header: "ID", accessor: "Id" },
      { id: "FirstName", Header: "FirstName", accessor: "FirstName" },
      { id: "LastName", Header: "LastName", accessor: "LastName" },
      { id: "Email", Header: "Email Id", accessor: "Email" },
      { id: "Role", Header: "Role", accessor: "RoleName" },
      {
        id: "Status",
        Header: "Account Status",
        accessor: "Status",
        Cell: ({ value }) => <span>{value === 1 ? "Active" : "Deactivated"}</span>
      },
      {
        id: "CapabilitiesArr",
        Header: "Capabilites",
        accessor: "CapabilitiesArr",
        Cell: ({ value }) => (
          <div className="d-flex flex-wrap">
            {value &&
              value.map((capability: string, index: number) => {
                return (
                  <ul
                    style={{ listStyleType: "disc", marginBottom: "0px" }}
                    key={index}
                    className="col-12"
                  >
                    <li className="mb-0">{capability}</li>
                  </ul>
                );
              })}
          </div>
        ),
      },
      
    ],
    []
  );

  const data = useMemo(() => adminList, [adminList])!;

  const TableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    TableInstance;
  let index = 0; //to revisit later

  // const updateInput = (event: any): void => {
  //   console.log(event.target.name, event.target.value)

  //   setState({
  //     data: {
  //       ...state.data,
  //       [event.target.name]: event.target.value,
  //     },
  //   });
  // };

  const handleDelete = async (event: React.MouseEvent,userId: number) => {
    event.stopPropagation();
    if (window.confirm("Do you need to deactivate the user?")) {
      const response = await AdminUserService.deleteAdminUser(userId);
      if (response.data.data != null) {
        getAdminList();
        alert("User deactivated Successfully");
      } else {
        alert(response.data.errors);
      }
      
    }
  };

  const addUser = async (data: any) => {
    const response = await AdminUserService.createAdminUser(data);
    console.log("response", response);
    if (response.data.data != null) {
      getAdminList();
      setaddUserOpen(false);
      alert("User added Successfully");
    } else {
      console.log("**error***");
      console.log(response.data.errors);
      alert(response.data.errors);
    }
  };
  const updateUser = async (data: any) => {
    const response = await AdminUserService.updateAdminUser(data);
    console.log("response", response);
    if (response.data.data != null) {
      getAdminList();
      setaddUserOpen(false);
      alert("User updated Successfully");
    } else {
      console.log("**error***");
      console.log(response.data.errors);
      alert(response.data.errors);
    }
  };

  const getRole = async () => {
    const response = await AdminUserService.getAdminRole();
    console.log("response", response);
    if (response.data.data != null) {
      response.data.data?.forEach((element: any) => {
        if (element.AdminCapabilities != null){
        element["CapabilitiesArr"] = element.AdminCapabilities.split(", ");
        }
      });
      setadminRoleList(response.data.data);
      // getAdminList();
      // setaddUserOpen(false)
      // alert('User added Successfully');
    } else {
      console.log("**error***");
      console.log(response.data.errors);
      alert(response.data.errors);
    }
  };
  const onSubmit = (data: AddFormValue) => {
    console.log(data.Roles);
    const FirstName = data.FirstName || "";
    const LastName = data.LastName || "";
    const Email = data.Email !== undefined ? data.Email : "";
    const Roles: any = data.Roles ? (isUpdate ? data.Roles : [data.Roles]) : [];
    let id = {
      Id: Id,
    };
    console.log("SUBMIT");
    console.log(data);

    const formData = {
      FirstName: FirstName,
      LastName: LastName,
      Email: Email,
      Roles: Roles,
      Role: Roles,
      Status: data.Status || 1
    };

    console.log(formData.Roles[0]);
    isUpdate ? updateUser({ ...formData, ...id }) : addUser(formData);
    // isUpdate ?console.log({...formData,...id},'update***********') : console.log(formData,'add&&&&&&&&&&&&&&');

    setaddUserOpen(false);
  };

  // const openDialog = () => {
  //   // getRole()
  //   reset()

  //   // setState({
  //   //   data: {
  //   //     FirstName: '',
  //   //     LastName: '',
  //   //     Email: 0,
  //   //     RoleName: ''
  //   //   }
  //   // })
  //   setisRoleSelected(false)
  //   // setValue('FirstName', '')
  //   // setValue('LastName', '')
  //   // setValue('Email', '')
  //   // setValue('Roles', 0)
  //   setisEdit(false)
  //   setisEmailEdit(false)
  //   setdialogTitle('Add User')
  //   setbuttonName('Add')
  //   setisUpdate(false)
  //   setselectedAdminCapabilities([])
  //   setaddUserOpen(true)
  // }

  const openDialog = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("settings.create")
      )
    ) {
      alert("No Access");
      return;
    }
    reset();
    const roleDropdown = document.getElementById("Roles") as HTMLSelectElement;
    if (roleDropdown) {
      roleDropdown.selectedIndex = 0;
    }
    setisRoleSelected(false);
    setisEdit(false);
    setisEmailEdit(false);
    setdialogTitle("Add User");
    setbuttonName("Add");
    setisUpdate(false);
    setselectedAdminCapabilities([]);
    setaddUserOpen(true);
  };

  const updateInput = async (event: any) => {
    const selectedRoleId = parseInt(event.target.value);
    console.log(selectedRoleId);
    setValue("Roles", event.target.value);

    const selectedRole = adminRoleList.find(
      (role: any) => role.Id === selectedRoleId
    );
    console.log(selectedRole);

    if (selectedRole) {
      setselectedAdminCapabilities(selectedRole.CapabilitiesArr);
      setisRoleSelected(true);
      console.log(selectedAdminCapabilities);
    } else {
      setselectedAdminCapabilities([]);
    }
    // trigger("Roles");

    //  await trigger(event.target.name);
  };

  const handleClose = () => {
    reset();
    setaddUserOpen(false);
  };

  const handleEdit = () => {
    console.log("EDit user");
    setdialogTitle("Update User");
    setbuttonName("Update");
    setisEdit(false);
    setisUpdate(true);

    if (selectedRow && selectedRow.CapabilitiesArr) {
      setselectedAdminCapabilities(selectedRow.CapabilitiesArr);
    }
  };

  return (
    <div className="container-fluid">
      <div className="dashboard-content-wrapper">
        <div
          className="d-flex justify-content-between"
          style={{ width: "90%" }}
        >
          <h1 className="page-heading">User List</h1>
          <div className="settings-add-button ms-4">
            <div className="secondary-button" onClick={() => openDialog()}>
              <AddCircleOutlineIcon></AddCircleOutlineIcon>
              <span className="ps-1">Add User</span>
            </div>
          </div>
        </div>
        <div className="adminlist-table">
          <table {...getTableProps}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps} key={index++}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    key={row.index}
                    onClick={() => showCapabilities(row.original)}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}> {cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <ReactModal
        isOpen={addUserOpen}
        className="addtype-modal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "1rem", zIndex: "20", height: "5%" }}
        >
          <div className="d-flex">
            <h1
              className="page-heading"
              // style={{ marginBottom: "2rem", }}
            >
              {dialogTitle}
            </h1>
            <a
              style={{ display: isEdit ? "flex" : "none" }}
              className="editRow justify-content-center pt-1 ms-3"
              onClick={() => handleEdit()}
            >
              <EditIcon></EditIcon>
            </a>
          </div>

          <PageLink
            onClick={() => handleClose()}
            style={{ marginBottom: "1rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100">
              <Label>First Name</Label>
              <input
                className="input-field-div"
                placeholder="First Name"
                {...register("FirstName", {
                  required: "First Name is required",
                })}
                id="FirstName"
                name="FirstName"
                disabled={isEdit}
              />
              <p className="form-error form-error-position">
                {errors.FirstName?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper w-100 mx-3">
              <Label>Last Name</Label>
              <input
                className="input-field-div"
                placeholder="Last Name"
                {...register("LastName", { required: "Last Name is required" })}
                id="LastName"
                name="LastName"
                disabled={isEdit}
              />
              <p className="form-error form-error-position">
                {errors.LastName?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper w-100">
              <Label>Email ID</Label>
              <input
                className="input-field-div"
                placeholder="Email Id"
                {...register("Email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address",
                  },
                })}
                id="Email"
                name="Email"
                disabled={isEmailEdit}
              />
              <p className="form-error form-error-position">
                {errors.Email?.message}
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div className="input-field-div-wrapper user-select-input w-100">
              <select
                {...register("Roles", {
                  required: "Role is required",
                  onChange: updateInput,
                })}
                id="Roles"
                name="Roles"
                className="dropdown-control-large-insidetextfield"
                disabled={isEdit}
                // onChange={updateInput}
                defaultValue=""
              >
                <option disabled={true} value="">
                  --Roles--
                </option>
                {adminRoleList?.map((Role: any) => (
                  <option key={Role.Id} value={Role.Id}>
                    {Role.RoleName}
                  </option>
                ))}
              </select>
              <p className="form-error form-error-position">
                {errors.Roles?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper user-select-input w-100 mx-3">
              <Label>Status</Label>
              <select
                {...register("Status", {
                  required: "Status is required"
                })}
                id="Status"
                name="Status"
                className="dropdown-control-large-insidetextfield"
                disabled={isEdit}
              >
                <option value="1">Active</option>
                <option value="2">Deactivate</option>
              </select>
              <p className="form-error form-error-position">
                {errors.Status?.message}
              </p>
            </div>
          </div>
          <div
            className="w-100 h-100"
            style={{ display: !isEdit ? "block" : "none", fontSize: "0.8rem" }}
          >
            <Label style={{ display: isRoleSelected ? "block" : "none" }}>
              Capabilities
            </Label>
            <div className="d-flex flex-wrap text-black-50">
              {selectedAdminCapabilities &&
                selectedAdminCapabilities.map(
                  (capability: string, index: number) => {
                    return (
                      <ul
                        style={{ listStyleType: "disc", marginBottom: "0px" }}
                        key={index}
                        className="col-4"
                      >
                        <li className="mb-0">{capability}</li>
                      </ul>
                    );
                  }
                )}
            </div>
          </div>
          <div
            className="w-100 h-100"
            style={{ display: isEdit ? "block" : "none", fontSize: "0.8rem" }}
          >
            <Label>Capabilities</Label>
            {/* <div className="input-field-div-wrapper w-100">
              <Label>Capabilities</Label>
              <input
                className="input-field-div"
                placeholder="Capabilities"
                {...register("Capabilities", { required: false})}
                id="Capabilities"
                name="Capabilities"
                disabled={isEdit}

              />
            </div> */}
            {/* <div>
              {selectedRow?.AdminCapabilities}
            </div> */}
            <div className="d-flex flex-wrap mb-3 text-black-50">
              {selectedRow?.CapabilitiesArr &&
                selectedRow?.CapabilitiesArr.map(
                  (capability: string, index: number) => {
                    return (
                      <ul
                        style={{ listStyleType: "disc", marginBottom: "0px" }}
                        key={index}
                        className="col-4"
                      >
                        <li className="mb-0">{capability}</li>
                      </ul>
                    );
                  }
                )}
            </div>
          </div>
          <div
            style={{ display: !isEdit ? "flex" : "none" }}
            className="w-100 justify-content-center mt-4"
          >
            <div className="submit-button-div">
              <Button type="submit">{buttonName}</Button>
            </div>
          </div>
          {/* <div style={{ display: isEdit ? 'flex' : 'none' }} className="w-100 justify-content-center mt-4">
            <div className="submit-button-div">
              <Button onClick={() => handleEdit()}>Edit</Button>
            </div>
          </div> */}
        </form>
      </ReactModal>
    </div>
  );
};

export default AdminUserList;
